<template>
  <div class="login-device-page common-bg">
    <van-nav-bar fixed title="登录设备" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <!-- 顶部用户信息 -->
    <div class="device-header">
      <img src="/static/newImg/static/logo.png" class="device-logo" />
      <div class="divider"></div>
      <div class="device-user-info">
        <div class="device-user-row">
          <span class="device-id-label">ID:</span>
          <span class="device-id-text">{{ $store.state.userInfo.id }}</span>
          <img src="/static/newImg/index/copy01.png" class="device-copy-icon" @click="doCopy($store.state.userInfo.id)" />
        </div>
        <div class="device-user-row">
          <span class="device-account-label">账号</span>
          <span class="device-account-text">{{ $store.state.userInfo.username }}</span>
        </div>
      </div>
    </div>

    <!-- 自动退出登录 -->
    <div class="auto-logout-bar">
      <div class="auto-logout-left">
        <span class="auto-logout-title">自动退出登录</span>
        <span class="auto-logout-sub">（闲置时长）</span>
      </div>
      <div class="auto-logout-right" @click="showTimePicker = true">
        <span class="auto-logout-value">{{ timeOptions[timeIndex] }}</span>
        <van-icon name="arrow" color="#DFB372" size="14" />
      </div>
    </div>

    <!-- 当前设备 -->
    <div class="device-card">
      <div class="device-row current-device-row">
        <span class="current-device-title">
          <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
          </svg>
          <span>当前设备</span>
          <span class="current-check-icon">
            <svg width="18" height="18" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="11" fill="#22c55e"/>
              <path d="M9.5 16.2L5.8 12.5l1.4-1.4 2.3 2.3 7.3-7.3 1.4 1.4z" fill="#fff"/>
            </svg>
          </span>
        </span>
      </div>
      <div class="device-row" v-for="(item, idx) in currentDevice" :key="idx">
        <span class="device-label">{{ item.label }}</span>
        <span class="device-value">{{ item.value }}</span>
      </div>
    </div>

    <!-- 其他设备 -->
    <div class="device-card other-device-card" v-for="(device, dIdx) in otherDevices" :key="dIdx">
      <div class="device-row other-device-row">
        <span class="other-device-title">
          <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
            <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
          </svg>
          <span>其他设备</span>
        </span>
        <van-icon name="delete-o" color="#ff3b30" size="18" @click="deleteDevice(device)" />
      </div>
      <div class="device-row" v-for="(item, idx) in device.rows" :key="idx">
        <span class="device-label">{{ item.label }}</span>
        <span class="device-value">{{ item.value }}</span>
      </div>
    </div>
    <div class="empty-tip" v-if="otherDevices.length === 0">暂无其他设备</div>

    <!-- 保存图片按钮 -->
    <div class="save-btn-wrap">
      <div class="save-btn" @click="saveImage" :class="{ active: saving }">{{ saving ? '生成中...' : '保存图片' }}</div>
    </div>

    <!-- 时间选择弹窗 -->
    <div class="time-picker-mask" v-if="showTimePicker" @click="showTimePicker = false">
      <div class="time-picker-content" @click.stop>
        <div class="time-picker-header">
          <span class="time-picker-cancel" @click="showTimePicker = false">取消</span>
          <span class="time-picker-title">自动退出登录</span>
          <span class="time-picker-confirm" @click="confirmTime">确定</span>
        </div>
        <div class="time-picker-body">
          <div class="time-picker-item" v-for="(opt, idx) in timeOptions" :key="idx"
               :class="{ active: timeIndex === idx }"
               @click="timeIndex = idx">
            {{ opt }}
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div class="preview-mask" v-if="showPreview" @click="closePreview">
      <div class="preview-content" @click.stop>
        <img :src="previewImage" class="preview-img" />
        <div class="preview-tip">长按图片保存到相册</div>
        <div class="preview-actions">
          <div class="preview-btn download" @click="downloadImage">下载图片</div>
          <div class="preview-btn cancel" @click="closePreview">关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import html2canvas from 'html2canvas';
export default {
  name: 'loginDevice',
  data() {
    return {
      showTimePicker: false,
      timeIndex: 3,
      timeOptions: ['1个月', '3个月', '6个月', '1年'],
      currentDevice: [
        { label: '客户端', value: 'H5(7.3.203)' },
        { label: '浏览器类型', value: 'Chrome v150.0.0.0' },
        { label: '操作系统', value: 'Windows' },
        { label: '系统版本', value: 'Windows 10' },
        { label: '设备品牌', value: '未知' },
        { label: '设备型号', value: 'Chrome v150.0.0.0' },
        { label: 'IP地区', value: '203.132.63.50 China/Guangdong-Guangzhou' },
        { label: '登录时间', value: '(UTC+8) 2026/07/13 18:32:18' },
      ],
      otherDevices: [
        {
          id: 0,
          rows: [
            { label: '客户端', value: 'H5(7.3.195)' },
            { label: '浏览器类型', value: 'Mobile Safari v13.0.3' },
            { label: '操作系统', value: 'iOS' },
            { label: '系统版本', value: 'iOS 13.2.3' },
            { label: '设备品牌', value: 'iPhone' },
            { label: '设备型号', value: 'Mobile Safari v13.0.3' },
            { label: 'IP地区', value: '120.84.12.200 China/Guangdong-Guangzhou' },
            { label: '登录时间', value: '(UTC+8) 2026/07/13 18:14:07' },
          ],
        },
        {
          id: 0,
          rows: [
            { label: '客户端', value: 'H5(7.3.190)' },
            { label: '浏览器类型', value: 'Chrome v148.0.0.0' },
            { label: '操作系统', value: 'Android' },
            { label: '系统版本', value: 'Android 13' },
            { label: '设备品牌', value: 'HUAWEI' },
            { label: '设备型号', value: 'Pura 70' },
            { label: 'IP地区', value: '58.236.11.88 China/Guangdong-Shenzhen' },
            { label: '登录时间', value: '(UTC+8) 2026/07/12 22:05:33' },
          ],
        },
      ],
      loading: false,
      saving: false,
      previewImage: '',
      showPreview: false,
    };
  },
  mounted() {
    this.loadDevices();
  },
  methods: {
    loadDevices() {
      this.loading = true;
      this.$apiFun.post('/api/loginDevices').then(res => {
        if (res.code === 200) {
          const data = res.data || {};
          // 当前设备：rows 数组格式 [{label,value}]，正好适配
          this.currentDevice = (data.current_device && Array.isArray(data.current_device.rows)) ? data.current_device.rows : [];
          // 其他设备：[{id, rows:[{label,value}]},...]
          const others = Array.isArray(data.other_devices) ? data.other_devices : [];
          this.otherDevices = others.map(d => ({
            id: (d && d.id) ? d.id : 0,
            rows: (d && Array.isArray(d.rows)) ? d.rows : [],
          }));
          // 自动退出时长 1=1个月 2=3个月 3=6个月 4=1年
          const duration = data.auto_logout_duration || 4;
          this.timeIndex = Math.max(0, Math.min(3, duration - 1));
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.$parent.showTost(1, '复制成功！');
    },
    confirmTime() {
      this.showTimePicker = false;
      const duration = this.timeIndex + 1;
      this.$apiFun.post('/api/loginDevice/autoLogout', { duration }).then(res => {
        if (res.code === 200) {
          this.$parent.showTost(1, '设置成功');
        } else {
          this.$parent.showTost(0, (res && res.message) || '设置失败');
        }
      }).catch(() => {
        this.$parent.showTost(0, '设置失败');
      });
    },
    deleteDevice(device) {
      Dialog.confirm({
        title: '温馨提示',
        message: '是否下线该登录设备？',
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        className: 'login-device-dialog',
      }).then(() => {
        const deviceId = (device && device.id) ? device.id : 0;
        if (!deviceId) {
          // 无 id（模拟数据）直接从列表移除
          const idx = this.otherDevices.indexOf(device);
          if (idx >= 0) this.otherDevices.splice(idx, 1);
          return;
        }
        this.$apiFun.post('/api/loginDevice/deleteOne', { device_id: deviceId }).then(res => {
          if (res.code === 200) {
            const idx = this.otherDevices.findIndex(d => d && d.id === deviceId);
            if (idx >= 0) this.otherDevices.splice(idx, 1);
            this.$parent.showTost(1, '设备已下线');
          } else {
            this.$parent.showTost(0, (res && res.message) || '下线失败');
          }
        }).catch(() => {
          this.$parent.showTost(0, '下线失败');
        });
      }).catch(() => {});
    },
    saveImage() {
      if (this.saving) return;
      this.saving = true;
      Toast.loading({ message: '生成中...', forbidClick: true, duration: 0 });
      const target = this.$el;
      html2canvas(target, {
        backgroundColor: '#1a1a1a',
        scale: 2,
        useCORS: true,
        logging: false,
      }).then(canvas => {
        Toast.clear();
        this.saving = false;
        this.previewImage = canvas.toDataURL('image/png');
        this.showPreview = true;
      }).catch(err => {
        console.error('保存图片失败', err);
        Toast.clear();
        this.saving = false;
        this.$parent.showTost(0, '保存失败');
      });
    },
    closePreview() {
      this.showPreview = false;
      this.previewImage = '';
    },
    downloadImage() {
      const link = document.createElement('a');
      link.download = `登录设备_${Date.now()}.png`;
      link.href = this.previewImage;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.closePreview();
      this.$parent.showTost(1, '保存成功');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.login-device-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding-bottom: 2rem;

  .device-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.3rem;
    background: #292A2C;
    margin: 0.2rem 0.3rem;
    border-radius: 0.2rem;

    .device-logo {
      width: 4rem;
      height: auto;
      margin-right: 0.3rem;
      flex-shrink: 0;
    }

    .divider {
      border: 1px solid #424449;
      height: 0.5rem;
      margin: 0 0.3rem;
    }

    .device-user-info {
      flex: 0 0 auto;
      margin-left: 0.3rem;
      .device-user-row {
        display: flex;
        align-items: center;
        margin-bottom: 0.1rem;

        .device-id-label {
          color: #999;
          font-size: 0.3rem;
          margin-right: 0.1rem;
        }

        .device-id-text {
          color: #fff;
          font-size: 0.35rem;
        }

        .device-copy-icon {
          width: 0.45rem;
          height: 0.45rem;
          margin-left: 0.1rem;
        }

        .device-account-label {
          color: #999;
          font-size: 0.3rem;
          margin-right: 0.1rem;
        }

        .device-account-text {
          color: #fff;
          font-size: 0.35rem;
        }
      }
    }
  }

  .auto-logout-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0.3rem;
    margin: 0 0.3rem;

    .auto-logout-left {
      .auto-logout-title {
        color: #fff;
        font-size: 0.35rem;
      }

      .auto-logout-sub {
        color: #666;
        font-size: 0.28rem;
      }
    }

    .auto-logout-right {
      display: flex;
      align-items: center;
      cursor: pointer;

      .auto-logout-value {
        color: #DFB372;
        font-size: 0.3rem;
        margin-right: 0.1rem;
      }
    }
  }

  .current-device-header {
    display: flex;
    align-items: center;
    padding: 0.2rem 0.3rem;

    .current-device-title {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 0.35rem;

      span {
        margin-right: 0.1rem;
      }
    }
  }

  .device-card {
    background: #292A2C;
    margin: 0 0.3rem 0.2rem;
    border-radius: 0.2rem;
    padding: 0.2rem 0.3rem;

    .current-device-row {
      .current-device-title {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 0.36rem;
        font-weight: 500;

        > span:nth-child(2) {
          margin: 0 0.15rem 0 0.1rem;
        }
      }
    }

    .other-device-row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .other-device-title {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 0.36rem;
        font-weight: 500;

        > span:nth-child(2) {
          margin-left: 0.1rem;
        }
      }
    }

    .device-row {
      display: flex;
      justify-content: space-between;
      padding: 0.15rem 0;
      margin-bottom: 0.1rem;
      border-bottom: 1px solid #3a3a3a;

      &:last-child {
        border-bottom: none;
      }

      .device-label {
        color: #999;
        font-size: 0.3rem;
        flex-shrink: 0;
      }

      .device-value {
        color: #fff;
        font-size: 0.3rem;
        text-align: right;
        word-break: break-all;
        max-width: 60%;
      }
    }
  }

  .other-device-card {
    margin-top: 0.3rem;
  }

  .other-device-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0.3rem;

    .other-device-title {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 0.35rem;

      span {
        margin-left: 0.1rem;
      }
    }
  }

  .empty-tip {
    text-align: center;
    color: #666;
    font-size: 0.3rem;
    padding: 0.5rem 0;
  }

  .save-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.3rem;
    background: #1a1a1a;
    z-index: 10;

    .save-btn {
      background: #DFB372;
      color: #000;
      text-align: center;
      padding: 0.25rem;
      border-radius: 0.15rem;
      font-size: 0.32rem;
      cursor: pointer;
      margin:0.1rem 0 0.4rem 0;
    }
  }

  .time-picker-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .time-picker-content {
      width: 100%;
      background: #292A2C;
      border-radius: 0.3rem 0.3rem 0 0;

      .time-picker-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.3rem 0.4rem;
        border-bottom: 1px solid #3a3a3a;

        .time-picker-cancel {
          color: #999;
          font-size: 0.3rem;
          cursor: pointer;
        }

        .time-picker-title {
          color: #fff;
          font-size: 0.32rem;
        }

        .time-picker-confirm {
          color: #DFB372;
          font-size: 0.3rem;
          cursor: pointer;
        }
      }

      .time-picker-body {
        padding: 0.3rem 0;
        max-height: 5rem;
        overflow-y: auto;

        .time-picker-item {
          text-align: center;
          padding: 0.3rem 0;
          color: #999;
          font-size: 0.32rem;
          cursor: pointer;

          &.active {
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.login-device-dialog {
  background-color: #292A2C !important;
  border: 1px solid #3B3C3D !important;
  border-radius: 0.2rem !important;
  color: #fff !important;

  .van-dialog__header {
    color: #fff !important;
    font-size: 0.4rem !important;
    font-weight: bold !important;
    padding-top: 0.4rem !important;
  }

  .van-dialog__message {
    color: #fff !important;
    font-size: 0.32rem !important;
    text-align: center !important;
    padding: 0.3rem 0.4rem 0.5rem !important;
  }

  .van-dialog__footer {
    background-color: #292A2C !important;
    border-top: 1px solid #3B3C3D !important;
    padding: 0.2rem !important;
  }

  .van-dialog__cancel,
  .van-dialog__confirm {
    flex: 1 !important;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
    border-radius: 0.15rem !important;
    font-size: 0.32rem !important;
    margin: 0 0.15rem !important;
  }

  .van-dialog__cancel {
    background-color: transparent !important;
    color: #fff !important;
    border: 1px solid #666 !important;
  }

  .van-dialog__confirm {
    background-color: #d1ae52 !important;
    color: #703904 !important;
    border: none !important;
  }
}

.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  .preview-content {
    width: 100%;
    max-width: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .preview-img {
    width: 100%;
    border-radius: 0.15rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  }

  .preview-tip {
    color: #fff;
    font-size: 0.28rem;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
  }

  .preview-actions {
    display: flex;
    gap: 0.3rem;
    width: 100%;

    .preview-btn {
      flex: 1;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      border-radius: 0.15rem;
      font-size: 0.32rem;
      cursor: pointer;

      &.download {
        background: #d1ae52;
        color: #703904;
      }

      &.cancel {
        background: transparent;
        color: #fff;
        border: 1px solid #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginDevice.vue